import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe, FaChevronDown, FaCheck } from 'react-icons/fa';
import { useTheme } from '../../contexts/ThemeContext.jsx';

const LanguageSelector = ({ isCollapsed = false, dropUp = false }) => {
  const { i18n, t } = useTranslation();
  const { isDark } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'fr', name: t('language.french'), flag: '🇫🇷' },
    { code: 'en', name: t('language.english'), flag: '🇬🇧' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  if (isCollapsed) {
    return (
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-lg flex items-center justify-center transition-colors duration-200"
          title={t('language.selectLanguage')}
        >
          <span className="text-lg">{currentLanguage.flag}</span>
        </button>
        
        {isOpen && (
          <div className={`absolute left-0 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[120px] z-50 ${
            dropUp ? 'bottom-full mb-2' : 'top-full mt-2'
          }`}>
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => changeLanguage(lang.code)}
                className={`w-full px-3 py-2 text-left hover:bg-gray-50 flex items-center justify-between ${
                  i18n.language === lang.code ? 'bg-blue-50 text-blue-600' : 'text-gray-700'
                }`}
              >
                <div className="flex items-center">
                  <span className="mr-2">{lang.flag}</span>
                  <span className="text-sm">{lang.name}</span>
                </div>
                {i18n.language === lang.code && (
                  <FaCheck className="text-blue-600 text-xs" />
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-colors duration-200 ${
          isDark 
            ? 'bg-gray-700 hover:bg-gray-600' 
            : 'bg-gray-100 hover:bg-gray-200'
        }`}
      >
        <div className="flex items-center">
          <FaGlobe className={`mr-2 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} />
          <span className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-700'}`}>
            {currentLanguage.flag} {currentLanguage.name}
          </span>
        </div>
        <FaChevronDown className={`text-xs transition-transform duration-200 ${isOpen ? 'rotate-180' : ''} ${isDark ? 'text-gray-400' : 'text-gray-500'}`} />
      </button>
      
      {isOpen && (
        <>
          {/* Overlay pour fermer en cliquant en dehors */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          
          <div className={`absolute left-0 right-0 rounded-lg shadow-lg border py-2 z-50 ${
            dropUp ? 'bottom-full mb-1' : 'top-full mt-1'
          } ${
            isDark 
              ? 'bg-gray-700 border-gray-600' 
              : 'bg-white border-gray-200'
          }`}>
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`w-full px-3 py-2 text-left flex items-center justify-between ${
                i18n.language === lang.code 
                  ? isDark 
                    ? 'bg-blue-900/50 text-blue-400' 
                    : 'bg-blue-50 text-blue-600'
                  : isDark
                    ? 'text-gray-300 hover:bg-gray-600'
                    : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <div className="flex items-center">
                <span className="mr-2">{lang.flag}</span>
                <span className="text-sm">{lang.name}</span>
              </div>
              {i18n.language === lang.code && (
                <FaCheck className={`text-xs ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
              )}
            </button>
          ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;




